import {
    FetchState,
    RevealPersonalInformationRequest,
    RevealPersonalInformationResponse,
    RevealState,
} from "@/shared/types";
import * as UserService from "@/shared/api/userService";
import * as storeHelper from "@/shared/storeHelper";
import { defineStore } from "pinia";
import _ from "lodash";
import { useNotifierStore } from "@/shared/store/notifier";

export const initialState: RevealState = {
    revealState: FetchState.Uninitialized,
    revealedInformation: null
};
export const useRevealPersonalInformationStore = defineStore("revealPersonalInformation", {
    state: (): RevealState => (_.cloneDeep(initialState)),
    getters: {
        isRevealLoaded: state => state.revealState === FetchState.Loaded,
    },
    actions: {
        setReveal (response) {
            this.revealedInformation = response;
            this.revealState = FetchState.Loaded;
        },
        setRevealLoading () {
            this.revealState = FetchState.Loading;
        },
        finishedViewingInformation () {
            this.revealState = FetchState.Uninitialized;
            this.revealedInformation = null;
        },
        resetState () {
            this.revealState = FetchState.Uninitialized;
        },
        adminPortalRevealPersonalInformation (request: RevealPersonalInformationRequest):
            Promise<RevealPersonalInformationResponse> {
            if (this.revealState !== FetchState.Uninitialized) {
                return;
            }
            this.setRevealLoading();
            const notifierStore = useNotifierStore();
            return UserService.putAdminPortalRevealPersonalInformation(request).then(resp => {
                this.setReveal(resp.data);
                if (!resp.data) {
                    notifierStore.setDanger(`Ssn not found for this user`);
                }
            }).catch(err =>
                storeHelper.handleError({ error: err, rethrow: true })
            );
        },
        revealPersonalInformation (request: RevealPersonalInformationRequest):
            Promise<RevealPersonalInformationResponse> {
            if (this.revealState !== FetchState.Uninitialized) {
                return;
            }
            this.setRevealLoading();
            const notifierStore = useNotifierStore();
            return UserService.putRevealPersonalInformation(request).then(resp => {
                this.setReveal(resp.data);
                if (!resp.data) {
                    notifierStore.setDanger(`Ssn not found for this user`);
                }
            }).catch(err =>
                storeHelper.handleError({ error: err, rethrow: true })
            );
        },
    }
});